export const pageGroupMetaData = {
    fullWidth: true
}
